<script>
import Layout from "@/views/layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import EmployeeAPI from "@/services/employee/employeeAPI";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import CheckModal from "@/components/CheckModal";
import LogTable from "@/components/standard/ResponsibleSGSST/ResponsibleLogTable";
import Table from "@/components/standard/ResponsibleSGSST/components/ResponsibleTable";
import DontExist from "@/components/company/components/DontExist";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";
import revised_objetivesAPI from "@/services/standards/revised_objetives/revised_objetivesAPI";
import monitoring_objectivesAPI from "@/services/standards/revised_objetives/monitoring_objetivesAPI";
import CompanyAPI from "@/services/company/companyAPI";
import Pagination from "@/components/standard/revised_objectives/monitoring_objectivesPagination";

export default {
  page: {
    title: "Objetivos definidos, claros, medibles, cuantificables, con metas, documentos, revisados del SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    LogTable,
    Table,
    CheckModal,
    DontExist,
    Pagination,
  },
  data() {
    return {
      title: "2.2.1 Objetivos definidos, claros, medibles, cuantificables, con metas, documentos, revisados del SG SST",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Objetivos definidos",
          active: true,
        },
      ],

      submitted: false,

      role: 2,

      itemData: null,

      item1: null,
      itemStatus1: null,

      monitoring_objectives: {
        control_date: null,
        result: null,
        action_plan_date: null,
        activity: null,
        sinews: null,
        employee_id: null,
        file: [],
        companies_id: this.$store.getters["company/getCompany"].id || null,
        objective_id: this.$route.params.id,
        fulfillment: null,
      },

      revisedO: {
        objective: null,
        meta_simbol: null,
        meta_number: null,
        indicator: null,
        frequency: null,
        status: true,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      userSelected: null,
      usersList: [],

      list: [],
      lista: [],

      nit: this.$store.getters["company/getCompany"].nit || null,
      lastId: 1,
      file: null,
      employeeDesignSST: "",

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      company: this.$store.getters["company/getCompany"] || null,
      user: this.$store.state.auth || null,
      numero: null,
      loading: true,
      loading1: true,
      loading2: true,
      message: 'hello'
    };
  },
  validations: {
    sg_sstData: {
      employee: {
        required,
      },
      appointment_date: {
        required,
      },
    },
  },
  methods: {


    calculo() {
      this.numero = monitoring_objectives.result
    },
    /** 
     *This method get the item data.
     */
    getItemData() {
      ItemAPI.getItems(1)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * Method to know the status item.
     * @param {Number} - Item ID.
     * @param {Object} - Item to get.
     * @param {Number} -  Status item.
     */
    getStatusItem(ID, item, itemStatus) {
      CompanyItemsAPI.getStatus(this.companyID, ID)
        .then((response) => {
          item = response || null;
          itemStatus = response.status;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      monitoring_objectivesAPI.getAllmonitoring(this.$route.params.id)
        .then((response) => {
          let monitoreo = response.data.data;
          this.lista = monitoreo
          if (response.data.data[0]['monitoring_id']) {
            this.lastId = response.data.data[0]['monitoring_id'] + 1
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeStatusValue() {
      this.sg_sstData.status = !this.sg_sstData.status;
    },

    getRevised() {
      revised_objetivesAPI
        .getRevised(this.$route.params.id)
        .then((response) => {
          this.loading1 = false
          this.revisedO = {
            objective: response.objective,
            meta_simbol: response.meta_simbol,
            meta_number: response.meta_number,
            indicator: response.indicator,
            frequency: response.frequency,
            status: response.status,
            companies_id: response.companies_id,
          };
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false
        });
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        if(this.file === null){
          return true;
        }else{
          let url = "";
          if (process.env.VUE_APP_ENV === 'development') {
            url = `sst-dev/${this.nit}/2.2.1/${this.$route.params.id}/seguimiento/${this.lastId}/${this.monitoring_objectives.employee_id}/${this.file.name}`;
          } else {
            url = `sst-prod/${this.nit}/2.2.1/${this.$route.params.id}/seguimiento/${this.lastId}/${this.monitoring_objectives.employee_id}/${this.file.name}`;
          }
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.monitoring_objectives.file[0] = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true
      Swal.fire({
        title: "¡Esto puede tomar unos minutos!",
        type: "warning",
        confirmButtonClass: "btn btn-confirm mt-2",
      });
      this.loading1 = true
      let response = await this.uploadDocument();
      if (response) {
        monitoring_objectivesAPI.save(this.monitoring_objectives)
        .then((response) => {
            this.loading1 = false
            setTimeout(() => {
              Swal.fire({
                title: "¡Se ha registrado con éxito!",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            }, 2000);
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false
        });
      }else{
        this.loading1 = false
        setTimeout(() => {
          Swal.fire({
            title: "¡No se ha podido registrar!",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              this.usersList = res.employee
              this.loading1 = false;
            })
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    goPage(page) {
      window.location.href = page;
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 1)
        .then((response) => {
          this.item1 = response !== {} ? response : null;
          this.itemStatus1 = response.status ? response.status : null;
        })
        .catch((error) => {
          console.log(error);
        });

      CompanyItemsAPI.getStatus(this.companyID, 2)
        .then((response) => {
          this.item2 = response !== {} ? response : null;
          this.itemStatus2 = response.status ? response.status : null;
        })
        .catch((error) => {
          console.log(error);
        });

      CompanyItemsAPI.getStatus(this.companyID, 11)
        .then((response) => {
          this.item11 = response !== {} ? response : null;
          this.itemStatus11 = response.status ? response.status : null;
        })
        .catch((error) => {
          console.log(error);
        });

      CompanyItemsAPI.getStatus(this.companyID, 41)
        .then((response) => {
          this.item41 = response !== {} ? response : null;
          this.itemStatus41 = response.status ? response.status : null;
        })
        .catch((error) => {
          console.log(error);
        });
      this.loading2 = false;
    },

  },

  mounted() {
    this.getList()
    this.getUsers();
    this.getItems();
    this.getRevised()
    this.getItemData();
  },
};
</script>
  
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">

        <div v-if="!loading2 && classificationID <= 4">
          <div class="card">

            <div class="card-body">
              <div class="row">

                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      La empresa debe definir unos objetivos en SST que permitan darle cumplimiento a la política.

                      Estos objetivos deben expresar los propósitos que tiene la empresa con el SG SST, deben ser
                      redactados de manera clara, concisa, deben ser cuantificables, compatibles y coherentes.

                      A cada objetivo se le deben definir unas metas y un indicador que permita medir el resultado, el
                      cual será presentado a la Gerencia en la Revisión por la Dirección.
                    </p>

                  </CheckModal>
                </div>

              </div>

              <form calss="form-group">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-12 px-2" label="Objetivo" label-for="file">
                    <b-form-textarea disabled type="date" id="note" v-model="revisedO.objective">
                    </b-form-textarea>
                  </b-form-group>

                </div>

                <div class="form-row">

                  <b-form-group label-for="number" class="col-md-6 px-2" label="Estado">
                    <select id="type" disabled class="form-control" v-model="revisedO.status">
                      <b-form-select-option value="1">
                        Activo
                      </b-form-select-option>
                      <b-form-select-option value="0">
                        Inactivo
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group label-for="number" class="col-md-6 px-2" label="Frecuencia de medición">
                    <select id="type" disabled class="form-control" v-model="revisedO.frequency">

                      <b-form-select-option value="Mensual">
                        Mensual
                      </b-form-select-option>
                      <b-form-select-option value="Bimensual">
                        Bimensual
                      </b-form-select-option>
                      <b-form-select-option value="Trimestral">
                        Trimestral
                      </b-form-select-option>
                      <b-form-select-option value="Semestral">
                        Semestral
                      </b-form-select-option>
                      <b-form-select-option value="Anual">
                        Anual
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                </div>

                <div class="form-row">

                  <b-form-group label-for="number" class="col-md-1 px-2" label="Meta:">
                    <select id="type" disabled class="form-control" v-model="revisedO.meta_simbol">
                      <b-form-select-option value="<">
                        &lt;
                      </b-form-select-option>
                      <b-form-select-option value=">=">
                        &ge;
                      </b-form-select-option>

                    </select>
                  </b-form-group>
                  <b-form-group label-for="number" class="col-md-5 " label="Numero de la meta">
                    <b-form-input disabled type="number" id="date_exam" v-model="revisedO.meta_number">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group label-for="indicator" class="col-md-6 px-2" label="Indicador">
                    <b-form-input disabled type="number" id="date_exam" v-model="revisedO.indicator">
                    </b-form-input>
                  </b-form-group>
                </div>
              </form>

              <form class="form-group" @submit.prevent="save">
                <div class="form-row">
                  <b-form-group label-for="Fecha" class="col-md-6 px-2" label="Fecha actual">
                    <b-form-input value="2018-07-22" :disabled="!getRole('Crear') || !allowAccess()" type="date"
                      id="date_exam" v-model="monitoring_objectives.control_date">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group label-for="Resultado" class="col-md-6 px-2" label="Resultado">
                    <b-form-input name="result" id="result" :disabled="!getRole('Crear') || !allowAccess()" type="number"
                      v-model="monitoring_objectives.result">
                    </b-form-input>
                    <b-form-input hidden disabled v-model="monitoring_objectives.result"> {{ monitoring_objectives.result
                    }} </b-form-input>

                  </b-form-group>

                </div>

                <div class="form-row"
                  v-if="(revisedO.meta_simbol == '>=' && monitoring_objectives.result >= revisedO.meta_number) || (revisedO.meta_simbol == '<' && monitoring_objectives.result < revisedO.meta_number)">

                  <b-form-group label-for="Cumplimiento" class="col-md-6 px-2" label="Cumplimiento">
                    <b-form-input disabled type="text" id="date_exam" value="Cumple">
                    </b-form-input>
                  </b-form-group>
                  <b-form-input hidden type="text" id="cumplimiento" v-model="monitoring_objectives.fulfillment = 1">
                  </b-form-input>

                </div>

                <div class="form-row"
                  v-else="(revisedO.meta_simbol == '<' && monitoring_objectives.result < revisedO.meta_number) || (revisedO.meta_simbol == '>=' && monitoring_objectives.result >= revisedO.meta_number)">

                  <b-form-group label-for="Cumplimiento" class="col-md-6 px-2" label="Cumplimiento">
                    <b-form-input disabled type="text" id="date_exam" value="No cumple">
                    </b-form-input>
                  </b-form-group>
                  <b-form-input hidden type="text" id="cumplimiento" value="2"
                    v-model="monitoring_objectives.fulfillment = 2">
                  </b-form-input>

                  <h4 title="Ingrese el plan de acción correspondiente para cumplir con el objetivo propuesto."
                    class="col-md-12 px-2">Plan de acción</h4>
                  <hr />
                  <b-form-group label-for="Fecha" class="col-md-6 px-2" label="Fecha">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" type="date" id="date_exam"
                      v-model="monitoring_objectives.action_plan_date">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group label-for="Actividad" class="col-md-6 px-2" label="Actividad">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" type="text" id="date_exam"
                      v-model="monitoring_objectives.activity">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group label-for="Recursos" class="col-md-6 px-2" label="Recursos">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" type="text" id="date_exam" maxlength="200"
                      v-model="monitoring_objectives.sinews">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Responsable">
                    <select :disabled="!getRole('Crear') || !allowAccess()" required class="form-control"
                      v-model="monitoring_objectives.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                    <b-form-file class="mb-4" inline type="file" id="file" ref="file" name="file" browse-text="Buscar"
                      :placeholder="`Seleccione el archivo...`" drop-placeholder="Suelta acá..." v-model="file"
                      @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>

                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form class="form-inline">
                            <div class="form-group mr-2">
                              <label for="productssearch-input" class="sr-only">Buscar</label>
                              <input type="search" :disabled="!allowAccess()" class="form-control border-light"
                                id="productssearch-input" placeholder="Buscar..." />
                            </div>
                            <button :disabled="!allowAccess()" type="button" class="btn btn-primary mb-2 mb-sm-0">
                              <i class="mdi mdi-search-web"></i>
                            </button>

                          </form>

                        </div>

                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">Fecha</th>
                              <th class="text-center align-middle">Resultado</th>
                              <th class="text-center align-middle">Cumplimiento</th>
                              <th class="text-center align-middle">Documento</th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">

                              <td class="text-center align-middle">
                                {{ dato.control_date }}
                              </td>


                              <td class="text-center align-middle">
                                {{ dato.result }}
                              </td>

                              <td class="text-center align-middle">
                                {{ dato.fulfillment }}
                              </td>

                              <td class="text-center align-middle">
                              <button type="button" @click="goPage(dato.file)" class="btn btn-outline-primary btn-md">
                                <i class="bx bx-download"></i>
                              </button>
                            </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                      :to="{ path: `/forms/estandares/seguimiento-objetivos-editar/${dato.id}` }">Editar</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                                      v-on:click="deleteB(dato.id)">Eliminar</b-dropdown-item>

                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>


                          </tbody>
                        </table>
                        <div>
                          <Pagination ref="paginator" @fetch="(items) => (lista = items)" />
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </form>
            </div>
          </div>

        </div>

        <div v-else-if="!loading && !loading2 && classificationID > 3">
          <DontExist text="se debe calificar la empresa para poder proceder." />
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>
  
<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>